import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en'
import is from './is'
import detectLocale from './detectLocale'

Vue.use(VueI18n)

// Initial locale from the cached preference / browser language so there's no flash of the wrong
// language before /api/users/current resolves (baseLayout reconciles it with the saved server value).
export const initialLocale = detectLocale();

const i18n = new VueI18n({
    locale: initialLocale,
    fallbackLocale: 'en',
    messages: { en, is },
    // Missing keys fall back to English silently (unconverted components keep their hardcoded English).
    silentFallbackWarn: true,
    silentTranslationWarn: true
});

export default i18n;
